import React from 'react'
import { useHistory } from 'react-router-dom'

import { Botao } from 'src/componentes'
import { RotasAluno } from 'src/rotas/aluno'
import { Nacionalidade, PendenciasDocumentosAluno } from 'src/tipos'

import {
  BarraFundo,
  BarraPreenchida,
  Texto,
  Wrapper
} from './faixa-documentos-obrigatorios.styles'

interface Props {
  pendencias: PendenciasDocumentosAluno | null
  nacionalidade?: string
}

export const FaixaDocumentosObrigatorios: React.FC<Props> = ({
  pendencias,
  nacionalidade
}) => {
  const history = useHistory()

  if (
    !pendencias?.exigeDocumentos ||
    !pendencias.pendentes?.length
  ) {
    return null
  }

  const nomes = pendencias.pendentes.map(item => item.nome).join(', ')
  const total = pendencias.totalObrigatorios
  const enviados = pendencias.enviados
  const percentual = total > 0 ? Math.round((enviados / total) * 100) : 0
  const rota =
    nacionalidade === Nacionalidade[0]
      ? RotasAluno.MeusDocumentosBrasileiro
      : RotasAluno.MeusDocumentosEstrangeiro

  return (
    <Wrapper>
      <Texto>
        Faltam {pendencias.pendentes.length} documentos obrigatórios para emitir
        seu certificado — {nomes}. Sem o diploma aprovado, seus atestados saem
        como curso de Extensão.
      </Texto>
      <BarraFundo>
        <BarraPreenchida percentual={percentual} />
      </BarraFundo>
      <Botao
        texto="Enviar documentos"
        type="button"
        onClick={() => history.push(rota)}
      />
    </Wrapper>
  )
}
